import {createSlice} from "@reduxjs/toolkit";
import saleWorkingSaga from "./saleWorkingSaga";
import {DATA_LIMIT} from "../../app/constants";

const saleWorking = createSlice({
	name: "saleWorking",
	initialState: {
		loading: false,
        error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
			haveAssign: false,
		},
        items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
	}
})
//Action
export const saleWorkingActions = saleWorking.actions;
//Reducers
export const saleWorkingReducer = saleWorking.reducer;
//Selectors
export const saleWorkingItemsSelector = (state) => state.saleWorking.items;
export const saleWorkingLoadingSelector = (state) => state.saleWorking.loading;
export const saleWorkingErrorSelector = (state) => state.saleWorking.error;
export const saleWorkingFilterSelector = (state) => state.saleWorking.filter;
export const saleWorkingPaginationSelector = (state) => state.saleWorking.pagination;